<template>
    <div>
      <Tables ref="tableGridsCadastroBasicoPivs"
                  :columns= colum
                  :showSearch="false"
                  :showPrint="false"
                  :newHeaderStatus="true"
                  :showDownload="false"
                  :showFullscreen="false"
                  v-on:Load="onLoadTable(categoria)"
                  style="font-family: 'Segoe UI'"
                  >
                  <tr v-for="(obj,index) in dados" :key="index">
                    <TableColumn :IsText="true" style="font-size: 12px;" :value="obj.descricao"></TableColumn>
                    <TableColumn :IsText="true" style="font-size: 12px;" :value="obj.dataCriacao"></TableColumn>
                    <TableColumn :IsText="true" style="font-size: 12px;" :value="obj.dataAlteracao"></TableColumn>

                            <TableColumn :IsText="false"
                                        :IsActiveButton="true"
                                        :HasChange="true"
                                        :newEditGama="true"
                                        :HasDelete="true"
                                        v-on:Edit="popUpEdicao(obj)"
                                        v-on:Delete="popUpExclusao(obj)"></TableColumn>
                  </tr>
                  <template #ButtonsAprova>
                  <div class="buttons-table-action">
                      <button class="btn-generate-lote-template-qma" @click="popUpAdd">+ ADICIONAR</button>
                  </div>
                  </template>
      </Tables>

      <b-modal ref="add-cadastro"
            size="md"
            centered
            id="add-edit-cadastro"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            >
            <template #modal-title>
                <div class="header-title">{{categoria === 0 && edicao === false ? 'ADICIONAR ASSINATURA' : categoria === 1 && edicao === false ? 'ADICIONAR CABEÇALHO' : categoria === 0 && edicao === true ? 'EDITAR ASSINATURA' :  'EDITAR CABEÇALHO'}}</div>
            </template>

            <div class="container-add-itens">
                  <label class="fontePopUp">Descrição</label>
                  <input v-model="novoItemDescricao" class="input-descricao" placeholder="Descrição Item"/>

                  <label v-if="categoria === 1" class="fontePopUp">Tipo do Campo</label>
                  <select v-if="categoria === 1" v-model="novoItemTipo" name="statusTipo" class="form-control" id="exampleFormControlSelect2">
                      <option :value = null disabled>Selecione o Tipo</option>
                      <option v-for="data in statusCabecalho" v-bind:key="data.value" :value="data.value">{{data.text}}</option>
                  </select>
            </div>

            <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="fechaPopAddEdicao">Cancelar</button>
                <button v-if="categoria === 1 && edicao === false" class="button-save" @click="salvarNovoItemCabecalho">Salvar</button>
                <button v-if="categoria === 1 && edicao === true" @click="salvarEdicaoItemCabecalho" class="button-save">Editar</button>
                <button v-if="categoria === 0 && edicao === false" class="button-save" @click="salvarNovoItemAssinatura">Salvar</button>
                <button v-if="categoria === 0 && edicao === true" @click="salvarEdicaoItemAssinatura" class="button-save">Editar</button>
            </div>
        </b-modal>

        <b-modal ref="exclusao"
            size="md"
            centered
            id="exclusao"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            >
            <template #modal-title>
                <div class="header-title">{{categoria === 0 ? 'EXCLUIR ASSINATURA' : 'EXCLUIR CABEÇALHO'}}</div>
            </template>

            <div class="icon-lixo"><i class="fas fa-trash" style="color: #b60000; font-size: 55px; text-align: center; margin-bottom: 1rem;"></i></div>

            <div class="font">Deseja proseguir com a exclusão {{categoria === 0 ? 'da assinatura' : 'do cabeçalho'}} <strong style="font: bold;">{{ item }}</strong>?</div>

            <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="fechaPopExclusao">Cancelar</button>
                <button v-if="categoria === 1"  class="button-save" @click="exclusaoItemCabecalho">Excluir</button>
                <button v-if="categoria === 0"  class="button-save" @click="exclusaoItemAssinatura">Excluir</button>
            </div>
        </b-modal>

        <!-- 2026-05-28: trava de exclusao - modal V3 com lista de templates em uso + acao "Remover deste template" por linha -->
        <b-modal ref="modalEmUso"
            size="lg"
            centered
            id="modalEmUso"
            :hide-footer="true"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            >
            <template #modal-title>
                <div class="header-title">ITEM EM USO</div>
            </template>

            <div style="font-size: 14px; margin-bottom: 1rem;">
                <i class="fas fa-exclamation-triangle" style="color: #e6a200; font-size: 22px; margin-right: 0.5rem; vertical-align: middle;"></i>
                Este item está em uso em <strong>{{ templatesEmUso.length }}</strong> template(s). Para excluí-lo, remova-o de cada template abaixo. Quando a lista esvaziar, a exclusão acontece automaticamente.
            </div>

            <div style="max-height: 360px; overflow-y: auto; border: 1px solid #e0e0e0; border-radius: 4px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <thead>
                        <tr style="background: #f5f5f5; text-align: left;">
                            <th style="padding: 8px 12px;">Código</th>
                            <th style="padding: 8px 12px;">Fluxo</th>
                            <th style="padding: 8px 12px;">Revisão</th>
                            <th style="padding: 8px 12px; width: 1px; white-space: nowrap;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="t in templatesEmUso" :key="t.juncaoId" style="border-top: 1px solid #efefef;">
                            <td style="padding: 8px 12px;">{{ t.codigo }}</td>
                            <td style="padding: 8px 12px;">{{ t.fluxo }}</td>
                            <td style="padding: 8px 12px;">{{ t.revisao }}</td>
                            <td style="padding: 8px 12px;">
                                <button class="button-save" style="padding: 4px 12px; font-size: 12px;" @click="removerDoTemplate(t.juncaoId)">Remover deste template</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="container-buttons-form pt-3">
                <button class="button-cancel" @click="fechaModalEmUso">Fechar</button>
            </div>
        </b-modal>

     </div>
</template>

<script>
import tableQma from './tableQma'
export default tableQma
</script>

  <style scoped>
  .fontePopUp {
    font-family: 'Segoe UI';
    font-size: 14px;
    font-weight: bold;
  }
  .icon-lixo{
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .font {
    width: 100%;
    line-height: 1.5rem ;
    text-align: center;
    font-family: 'Segoe UI';
    font-size: 18px;
    color: #505050;
  }
  .container-buttons-form{
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
  }
  .icone-alerta {
    display: flex;
    margin: 1rem 0 1rem 0;
    justify-content: center;
    font-size: 55px;
    color: darkgreen;
  }
  .font-clone{
    display: flex;
    justify-content: center;
    color: rgb(128, 128, 128);
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }
  .button-cancel{
    background-color: #b60000;
    color: white;
  }
  .button-save{
    background-color: darkgreen;
    color: white;
  }
  #impor-ex-price{
    display: none;
  }
   .novoTemplate {
      padding: 0.5rem 3rem 0.5rem 3rem
   }
   .descricaoArea{
      width: 100%;
      height: 5rem;
      border-color: #b3b3b3;
      border-radius: 1px;
   }
   .header-title{
    color: white;
    font-weight: bold;
    font-size: 16px;
    font-family: 'Segoe UI';
  }
  .btn-generate-lote-template-qma {
      height: 2rem;
      padding: 0 1rem;
      background: #008144;
      color: white;
      border-radius: 4px;
      width: fit-content;
      border: none;
      font-size: 10px;
  }
  .btn-generate-lote-template-qma:hover{
      background: #024d2a;
      width: fit-content;
  }
  .button-cancel,
  .button-save{
    margin-top: 10;
    font-size: 12PX;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
  }
   .container_cancel_save{
    justify-content: center;
    width: 100%;
    margin-top: 1.5rem;
    column-gap: 10px;
   }
  .button-cancel{
    background-color: #b60000;
    color: white;
  }
  .button-save{
    background-color: darkgreen;
    color: white;
  }
  .container-add-itens{
      width: 100%;
      height: fit-content;
      overflow: auto;
  }
  .container-add-itens::-webkit-scrollbar-track {
    background-color: #F4F4F4;
    border-radius: 10px;
  }
  .container-add-itens::-webkit-scrollbar {
      width: 6px;
      background: #F4F4F4;
      border-radius: 10px;
  }
  .container-add-itens::-webkit-scrollbar-thumb {
      background: #dad7d7;
      border-radius: 10px;
  }
  .input-descricao{
      width: 100%;
      margin-top: 0.5rem;
      height: 2rem;
      color: #585858;
      border: 1px solid rgb(216, 216, 216);
      border-radius: 2px;
      padding-left: 17px;
      margin-bottom: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/qma/registerbasicQMA/components/tableQma/tableQma.vue